// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartPropsMappingSource.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { get, has } from 'lodash/fp';
import { CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';
import { isChartType } from 'logic/data/Izenda.ReportPartChartConstants';

export default (reportPartDetails, fieldStore) => {
  const reportPartContent = reportPartDetails.reportPartContent || {};
  const getProperties = key => reportPartContent.getReportPartProperties(key);

  return {
    hideByChartType: optName => {
      return !has(optName, reportPartContent.defaultOptionsByType);
    },
    hideByChartTypeAndMetrics: optName => {
      const isHideByChartType = !has(optName, reportPartContent.defaultOptionsByType);
      // just only show the option only when there is one metric
      const isHideByMetrics = reportPartContent.isDisableMultiColor;

      return isHideByChartType || isHideByMetrics;
    },
    isNotBuild: () => !reportPartContent.isBeingBuild,
    /**
     * Check to hide page break after separator.
     */ doesHidePageBreakAfterSeparator() {
      const chartType = get('properties.chartType', reportPartContent);
      return (
        this.isNotBuild() ||
        !isChartType(chartType, CHART_TYPE.Pie, CHART_TYPE.Donut, CHART_TYPE.Funnel, CHART_TYPE.TreeMap)
      );
    },
    isBeingBuild: () => reportPartContent.isBeingBuild,
    getClassNameByChartStatus: () => (reportPartContent.isBeingBuild ? 'chart-being-build' : 'chart-not-build'),
    getChartType: () => reportPartContent.chartType,
    getUseSeparator: () => getProperties('izUseSeparator'),
    getLabelOrientationX: () => getProperties('izLabelOrientationX') || 'izNormal',
    getLabelOrientationY: () => getProperties('izLabelOrientationY') || 'izNormal',
    getValueByKey: getProperties,
    getReportPartDetails: () => reportPartDetails,
    getFieldStore: () => fieldStore,
    doesHideSingleYAxis: optName =>
      !has(optName, reportPartContent.defaultOptionsByType) || reportPartContent.numberOfMetric <= 1
  };
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.DefaultChartPropsMappingSource.js